import React from "react";

const SidebarItem = ({ name, songOptions, playingTitle }) => {
  return (
    <div
      className={`md:px-2 px-1 py-2 mt-1 transition ease-in-out duration-100  hover:shadow-lg hover:text-white hover:bg-pink-600  cursor-pointer ${
        playingTitle === name ? "bg-pink-600 text-white" : "text-gray-500"
      }`}
      onClick={() => songOptions(name)}
    >
      <h2 className="md:text-lg text-xl">{name}</h2>
    </div>
  );
};

export default SidebarItem;
